import { NavLink } from 'react-router-dom';
import { css, styled } from 'styled-components';

import { theme } from '../../../styles';
import { getUrlType } from '../../../utils';
import { staticTextSmallStyle } from '../common/commonStyles';

const StyledList = styled.ul`
  display: flex;
  align-items: flex-end;
  column-gap: 30px;

  // Reset list style
  list-style: none;
  margin: 0;
  padding: 0;
`;
export const NavbarLinkList = ({ navbarLinks }: { navbarLinks: NavbarLinkProps[] }) => {
  return <StyledList>{navbarLinks.map(NavbarLink)}</StyledList>;
};

type NavbarLinkProps = {
  /** Start with "/" for internal links - https for external links  */
  to: string;
  name: string;
};

const NavbarLink = ({ to, name }: NavbarLinkProps) => {
  const urlType = getUrlType(to);
  return (
    <li key={name}>
      {urlType === 'external' ? (
        <StyledAnchor href={to} target="_blank" rel="noopener noreferrer">
          {name}
        </StyledAnchor>
      ) : (
        <StyledRouterNavLink to={to}>{name}</StyledRouterNavLink>
      )}
    </li>
  );
};

const linkStyle = css`
  ${staticTextSmallStyle};
  color: ${theme.colors.white};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledRouterNavLink = styled(NavLink)`
  ${linkStyle}

  // react-router adds a class called "active" if you're on the page
  // https://reactrouter.com/en/main/components/nav-link#default-active-class
  &.active {
    text-decoration: underline;
  }
`;

const StyledAnchor = styled.a`
  ${linkStyle}
`;
